import { openAttestationVerifiers as openAttestationVerifiers$1, openAttestationDnsTxtIdentityProof, openAttestationDnsDidIdentityProof, openAttestationEthereumTokenRegistryStatus, openAttestationEthereumDocumentStoreStatus, openAttestationDidSignedDocumentStatus, openAttestationHash } from '@tradetrust-tt/tt-verify';
export { createResolver, getIdentifier, isValid, utils, verificationBuilder, verify } from '@tradetrust-tt/tt-verify';
import { w3cSignatureIntegrity } from './fragments/document-integrity/w3cSignatureIntegrity';
import { ecdsaW3CSignatureIntegrity } from './fragments/document-integrity/ecdsaW3CSignatureIntegrity';
import { credentialStatusTransferableRecordVerifier } from './fragments/document-status/transferableRecords/transferableRecordVerifier';
import { w3cCredentialStatus } from './fragments/document-status/w3cCredentialStatus';
import { w3cIssuerIdentity } from './fragments/issuer-identity/w3cIssuerIdentity';
import { w3cEmptyCredentialStatus } from './fragments';
import { bbs2023W3CSignatureIntegrity } from './fragments/document-integrity/bbs2023W3CSignatureIntegrity';

const verifiers = {
  documentIntegrity: {
    openAttestationHash,
    w3cSignatureIntegrity
  },
  documentStatus: {
    openAttestationDidSignedDocumentStatus,
    openAttestationEthereumDocumentStoreStatus,
    openAttestationEthereumTokenRegistryStatus,
    w3cCredentialStatus,
    w3cEmptyCredentialStatus,
    credentialStatusTransferableRecordVerifier
  },
  issuerIdentity: {
    openAttestationDnsDidIdentityProof,
    openAttestationDnsTxtIdentityProof,
    w3cIssuerIdentity
  }
};
const openAttestationVerifiers = [...openAttestationVerifiers$1];
const w3cVerifiers = [
  w3cSignatureIntegrity,
  ecdsaW3CSignatureIntegrity,
  bbs2023W3CSignatureIntegrity,
  w3cCredentialStatus,
  credentialStatusTransferableRecordVerifier,
  w3cEmptyCredentialStatus,
  w3cIssuerIdentity
];

export { openAttestationVerifiers, verifiers, w3cVerifiers };
